var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 27.4755L26.1909 16.1955C28.603 13.5256 28.603 9.19681 26.1909 6.52691C23.7788 3.857 19.868 3.857 17.4558 6.52691L16.6704 7.39632C16.3003 7.80597 15.7003 7.80612 15.33 7.39678C15.3299 7.39663 15.3302 7.39694 15.33 7.39678L14.5442 6.5269C12.132 3.857 8.22121 3.857 5.80909 6.52691C3.39697 9.19681 3.39697 13.5256 5.80909 16.1955L16 27.4755ZM24.8502 8.01095C26.5218 9.86124 26.5218 12.8612 24.8502 14.7115L16 24.5074L7.14984 14.7115C5.4782 12.8612 5.4782 9.86124 7.14985 8.01095C8.82149 6.16065 11.5318 6.16065 13.2034 8.01095L16 11.1064L18.7966 8.01095C20.4682 6.16065 23.1785 6.16065 24.8502 8.01095Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.cdbb444a55ab4004e98a85a06ab9abde.svg";
export { ForwardRef as ReactComponent };